import AnchorEditor from '@intercom/embercom-composer/components/anchor-editor';
export default AnchorEditor;
